import { fuelSeries } from "../ChartConfigFiles/Options";

const getDate = (entry, dataset) => {
  let date;
  if (dataset.temporalResolution === "yearly") {
    date = entry.year;
  } else if (dataset.temporalResolution === "monthly") {
    date = new Date(entry.date).getTime();
  }

  return date;
};

// Function to transform data for a single country
const transformSingleData = (dataset, response = null, dataTreatment) => {
  const responseData = response.map((entry) => {
    return {
      // year: new Date(entry.date).getFullYear(),
      date: getDate(entry, dataset),
      value: getValue(entry, dataset, dataTreatment),
      variable: entry.variable,
    };
  });

  let series = [];

  fuelSeries.forEach((fuel) => {
    let data = [];
    responseData.forEach((datapoint) => {
      if (datapoint.variable === fuel.name) {
        data.push({
          x: datapoint.date,
          y: datapoint.value,
        });
      }
    });
    series.push({
      name: fuel.name,
      data: data,
      color: fuel.color,
    });
  });

  return series;
};

// Function to transform data for a multiple countries
const transformMultiData = (
  dataset,
  response = null,
  dataTreatment,
  selectedCountries
) => {
  const responseData = response.map((entry) => {
    return {
      country_or_region: entry.state,
      date: getDate(entry, dataset),
      value: getValue(entry, dataset, dataTreatment),
      variable: entry.variable,
    };
  });

  let series = [];

  selectedCountries.forEach((country_or_region) => {
    let data = [];
    responseData.forEach((datapoint) => {
      if (datapoint.country_or_region === country_or_region) {
        data.push({
          x: datapoint.date,
          y: datapoint.value,
        });
      }
    });

    if (!data.length) {
      return;
    }

    series.push({
      name: country_or_region,
      data: data,
    });
  });

  return series;
};

const getValue = (entry, dataset, dataTreatment) => {
  let value;
  if (dataTreatment === "absolute") {
    value = transformFloatValues(entry[dataset.absoluteVariable]);
  } else {
    value = transformFloatValues(entry[dataset.relativeVariable]);
  }

  return value;
};

// Function to transform data for a all countries
const transformAllData = (response = null, dataset, dataTreatment) => {
  const responseData = response
    .map((entry) => {
      return {
        country_or_region: entry.country_or_region,
        country_code: entry.country_code,
        date: getDate(entry, dataset.temporalResolution),
        value: getValue(entry, dataset, dataTreatment),
        variable: entry.variable,
      };
    })
    .filter((entry) => entry.country_code);

  return responseData;
};

const transformData = (toolConfig, response, selectedCountries) => {
  let data;

  if (toolConfig.chartType === "area" || toolConfig.chartType === "line") {
    if (toolConfig.comparison === "off") {
      data = transformSingleData(
        toolConfig.dataset,
        response,
        toolConfig.dataTreatment
      );
    } else {
      data = transformMultiData(
        toolConfig.dataset,
        response,
        toolConfig.dataTreatment,
        selectedCountries
      );
    }
  } else {
    data = transformAllData(
      response,
      toolConfig.dataset,
      toolConfig.dataTreatment
    );
  }

  return data;
};

const transformFloatValues = (value) => {
  let transformedValue;
  if (typeof value === "string") {
    transformedValue = null;
  } else {
    transformedValue = parseFloat(value.toFixed(2));
  }

  return transformedValue;
};

export { transformData, transformMultiData, transformAllData };
